<div class="flex h-full w-full flex-col">
  <app-toolbox [sections]="toolboxSections()" [searchConfig]="searchCfg" />

  <div class="flex h-full min-h-0 flex-1 flex-col">
    @if (selectedCardId()) {
      <as-split
        direction="vertical"
        unit="percent"
        class="h-full w-full"
        [useTransition]="true">
        <as-split-area [visible]="true">
          <app-cards-list
            [config]="featureListConfig()"
            class="mt-0.5 min-h-0 w-full overflow-hidden rounded-sm" />
        </as-split-area>
        <as-split-area [visible]="true">
          <app-form class="w-full overflow-hidden" />
        </as-split-area>
      </as-split>
    } @else {
      <app-cards-list
        [config]="featureListConfig()"
        class="mt-0.5 h-full min-h-0 w-full overflow-hidden rounded-sm" />
    }
  </div>
</div>
